// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__DSdmE","page-select":"styles_page-select__FLOet","pagination-hide":"styles_pagination-hide__3dwxs"};